<template>
  <div :class="$style.container">
    <PageContainer v-if="!certsExist">
      <template v-slot:body>
        <PkiGettingStarted />
      </template>
    </PageContainer>
    <PageTabs
      v-if="!hidePageTabs"
      :tabConfig="$options.tabConfig"
    >
      <router-view />
    </PageTabs>
    <router-view
      v-else
    />
  </div>
</template>

<script>
import { PageContainer } from '@jumpcloud/ui-components';
import PageTabs from 'client/components/PageLayouts/PageTabs.vue';
import PkiGettingStarted from 'client/Pki/PkiGettingStarted.vue';

const tabConfig = [
  {
    name: 'All Certificates',
    label: 'All Certificates',
  },
  {
    name: 'Certificates Distribution',
    label: 'Certificates Distribution',
  },
];

export default {
  name: 'PkiMainPanel',

  tabConfig,

  components: {
    PageContainer,
    PageTabs,
    PkiGettingStarted,
  },

  data() {
    return {
      totalCount: null,
    };
  },

  computed: {
    certsExist() {
      return this.totalCount > 0;
    },
    hidePageTabs() {
      return this.$route.meta.hidePageTabs;
    },
  },

  created() {
    // @todo - prep for future BE calls
    this.getTotalCount();
  },

  methods: {
    getTotalCount() {
      // @todo - make async call to BE once APIs are built
      this.totalCount = 28;
    },
  },
};
</script>

<style module scoped>
.container {
  height: 100%;
}
</style>
